import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import './SharedModel.scss';


export default class SharedModel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let modalClass = 'SharedModel'
    const { visible, detailsData, hideCancel, className, replaceCancel } = this.props
    const { title, content, confirmText, cancelText, confirm, cancel, replaceFn, replaceCancelText } = detailsData
    
    if (className) {
      modalClass = `${modalClass} ${className}`
    }
    
    return (
      <Modal
        className={modalClass}
        title={title}
        visible={visible}
        onCancel={(e) => {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          cancel&&cancel(e)
        }}
        maskClosable={false}
        footer={null}
        // getContainer={() => {
        //   return this.props.saveRef || document.body
        // }}
      >
        <div className="contentBox">
          <p>{content}</p>
          <div className="btnBox">
            <Button className="confirmBtn" onClick={() => { confirm&&confirm() }}>{confirmText}</Button>
            {replaceCancel && <Button className="cancelBtn" onClick={(e) => { replaceFn && replaceFn(e) }}>{replaceCancelText}</Button>}
            {!hideCancel&&<Button className="cancelBtn" onClick={(e) => { cancel&&cancel(e) }}>{cancelText}</Button>}
          </div>
        </div>
      </Modal>
    );
  }
}
